import * as actionTypes from 'modules/appointments/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = false;

const isLoading = () => true;
const isEnding = () => false;

export default createReducer(initialState, {
  [actionTypes.FETCH_ATTENTION_POINTS_REQUEST]: isLoading,
  [actionTypes.FETCH_ATTENTION_POINTS_SUCCESS]: isEnding,
  [actionTypes.FETCH_ATTENTION_POINTS_FAILURE]: isEnding,
});
